export default {"src":"/_next/static/media/DegenerativeDiscDisease.cea2e8f2.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};